import axios from 'axios';
import config from '../config.js';

var root = config.backendHost();

let getConfig = function () {
    return {};
}

var http = axios.create({
    baseURL: root,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers':'*'
    }
});

function loadToken() {
    if (typeof localStorage.token !== 'undefined') {
        http.defaults.headers.common['auth_token'] = localStorage.token;
    }
}
function getToken() {
    return localStorage.token;
}
function clearToken() {
    delete http.defaults.headers.common['auth_token'];
    delete localStorage.token;
}

if (typeof localStorage.token !== 'undefined') {
    loadToken();
}

async function get(path) {
    return http.get(path, getConfig());
}

async function post(path, data) {
    return http.post(path, data, getConfig());
}

async function del(path) {
    return http.delete(path, getConfig());
}

async function patch(path, data) {
    return http.patch(path, data, getConfig());
}

async function isLoggedIn(admin) {
    try {
        let response = await get('/test/token');

        if (admin) {
            let isAdmin = response.data;
            if (isAdmin) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    } catch (err) {
        return false;
    }
}

export default {
    get: get,
    post: post,
    del: del,
    patch: patch,
    host: root,
    loadToken: loadToken,
    clearToken: clearToken,
    getToken: getToken,
    isLoggedIn: isLoggedIn
}